import React, { FC } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';

interface IProps {
  placement?: 'left';
}

const NoticeDot: FC<IProps> = ({ placement }) => {
  return (
    <div
      className={classNames(css.noticeDot, {
        [css[`noticeDot_placement_${placement}`]]: placement,
      })}
    ></div>
  );
};

export default NoticeDot;
